module.exports = __webpack_public_path__ + "img/style_0_0.4c5a267d.png";